<app-credit-create-submission-dialog
  [creditStructure]="data"
  [calculationStructure]="calculationStructure$ | async"
  [currentPortfolio]="currentPortfolio$ | async"
  (close)="onClose()"
></app-credit-create-submission-dialog>
